
  export default {
    props: {
      faqStatus: {
        type: Boolean,
        default: false
      },
      faqInitial: {
        type: String
      },
      faqInitialButton: {
        type: String
      },
      faqId: {
        type: String
      },
      collapseNumber: {
        type: Number
      },
      faqTitle: {
        type: String
      },
      faqAnswer: {
        type: String,
        default: ''
      },
      faqParent: {
        type: String,
        default: '#faqAccordian'
      }
    },
    methods:{
      getHtmlEncode(data) {
      return data.replace(/\n/g, '<br/>')
    },
    }
  }

